export default __webpack_public_path__ + "media/images/front/wavy/lighter_2-090e95dfb33727c88d62ceac468eb1a2.png";